import React from 'react';
import { useRecoilState } from 'recoil';

import { classPlaylistContent } from 'atoms/classPlaylistContent';
import { PlaylistMarkdownInput } from 'features/classCreation';

function PlaylistMarkdownContentInput() {
  const [content, setContent] = useRecoilState(classPlaylistContent);

  return (
    <PlaylistMarkdownInput
      value={content}
      onChange={setContent}
    />
  );
}

export default PlaylistMarkdownContentInput;
